import React from 'react';
import {Typography} from '@mui/material';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';
import {PlanValidationIcon} from '../CreateBuilder/BuilderSourceDestination/PlanValidationIcon';
import {usePlanValidationLevel} from '../CreateBuilder/BuilderSourceDestination/usePlanValidationLevel';
import {BuilderContributeSourceFields} from './BuilderContributeSourceFields';

// DOM/selector plumbing only — selection state lives on
// contributeFrom.sourceType, not on this id.
const NEW_CASH_ROW_ID = 'new-cash';

interface ContributeCashSourceRowProps {
  isSelected: boolean;
  handleChange: () => void;
}

export const ContributeCashSourceRow: React.FC<ContributeCashSourceRowProps> = ({
  isSelected,
  handleChange,
}) => {
  const activeFormikKey = isSelected ? 'contribute.contributeFrom' : undefined;
  const {bgClass} = usePlanValidationLevel(activeFormikKey);

  return (
    <PlanRow id={NEW_CASH_ROW_ID} reccId={null} isSelected={isSelected} isSubplan={false}>
      <PlanAccordionShell
        expanded={isSelected}
        isSelected={isSelected}
        isSoleParent
        validationLevel={bgClass}
        summaryChildren={
          <>
            <PlanSelector
              mode="single"
              id={NEW_CASH_ROW_ID}
              isSelected={isSelected}
              handleChange={handleChange}
            />
            <Typography>New cash contribution</Typography>
          </>
        }
        summaryTrailing={
          activeFormikKey ? (
            <PlanValidationIcon formikKeyPrefix={activeFormikKey} />
          ) : undefined
        }
      >
        <BuilderContributeSourceFields />
      </PlanAccordionShell>
    </PlanRow>
  );
};
